import useAutoCaptionGlobal from '@Hooks/auto-captions/useAutoCaptionGlobal';
import {useDispatch} from 'react-redux';
import {updateCommonCaption, updatePublishingParamAllCaptions, updatePublishingParamCaption} from '@Components/social-media-wizard/social-media-wizard-reducer';
import {closeModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import {GA4EventName} from '@Libraries/ga-events';
import {useAllPublishingParamsForAccount, useCommonCaption, useHasCommonCaption} from '@Components/social-media/social-media.hooks';
import {getNonStoryPublishingParams} from '@Libraries/social-media';
import type {AiGeneratedContent} from '@Components/ai-text-prompt-box/ai-text-prompt-box.types';

interface UseSelectCaptionType {
  chooseCaption: (caption: AiGeneratedContent) => void;
}

const useSelectCaption = (): UseSelectCaptionType => {
  const hasCommonCaption = useHasCommonCaption();
  const dispatch = useDispatch();
  const {closeAutoCaptionMode, inAutoCaptionMode} = useAutoCaptionGlobal();
  const commonCaption = useCommonCaption();
  const publishingParams = useAllPublishingParamsForAccount(inAutoCaptionMode.accountId ?? -1);

  // Note - nonStoryPublishingParams (POST / REEL) because STORIES do not have captions
  const publishingParamsForAccount = publishingParams ? getNonStoryPublishingParams(publishingParams) : null;

  const setCaptionInPostCaptionBox = (selectedAiCaption: AiGeneratedContent): void => {
    if (!publishingParamsForAccount) {
      return;
    }

    const currentCaptionValue = hasCommonCaption ? commonCaption : publishingParamsForAccount.caption;
    const currentCaptionPlusSelectedCaption = `${currentCaptionValue ? `${currentCaptionValue}\n` : ''}${selectedAiCaption.text}`;

    if (hasCommonCaption) {
      dispatch(updateCommonCaption(currentCaptionPlusSelectedCaption));
      dispatch(
        updatePublishingParamAllCaptions({
          caption: selectedAiCaption.text,
          isMultiCharacterChange: true,
        })
      );
    } else {
      dispatch(
        updatePublishingParamCaption({
          idSocialMediaAccount: inAutoCaptionMode.accountId ?? 0,
          caption: currentCaptionPlusSelectedCaption,
          isMultiCharacterChange: true,
        })
      );
    }

    dispatch(closeModal(MODALS_IDS.AUTO_CAPTIONS_MODAL));
    closeAutoCaptionMode();
    window.PMW.gtm.trackGA4CustomEvent(GA4EventName.SOCIALWIZARD_AICAPTIONS_ADDED);
  };

  return {
    chooseCaption: setCaptionInPostCaptionBox,
  };
};

export default useSelectCaption;
